const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCodeCubeLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "867px",
    height: "866px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#2c2bb5",
    d: "M 422.5,-0.5 C 429.167,-0.5 435.833,-0.5 442.5,-0.5C 565.501,4.75869 669.001,52.092 753,141.5C 845.085,247.81 880.085,370.81 858,510.5C 830.932,643.827 758.765,744.327 641.5,812C 583.011,843.702 520.677,861.535 454.5,865.5C 439.833,865.5 425.167,865.5 410.5,865.5C 286.639,856.818 183.806,806.151 102,713.5C 40.5479,639.679 6.38123,554.679 -0.5,458.5C -0.5,441.167 -0.5,423.833 -0.5,406.5C 11.9771,263.993 76.6438,152.16 193.5,71C 263.231,25.9846 339.564,2.15127 422.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfcfe",
    d: "M 408.5,23.5 C 519.885,19.6778 617.551,53.8445 701.5,126C 805.831,223.59 849.997,343.757 834,486.5C 812.936,615.139 747.103,713.305 636.5,781C 525.348,842.478 409.681,852.478 289.5,811C 172.296,764.796 91.7962,682.63 48,564.5C 9.17928,446.733 19.8459,333.733 80,225.5C 145.067,118.184 239.567,52.6837 363.5,29C 378.579,26.6487 393.579,24.8154 408.5,23.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b2bb5",
    d: "M 402.5,55.5 C 531.565,49.6408 638.065,95.3075 722,192.5C 800.375,293.343 824.042,406.009 793,530.5C 758.407,644.424 686.907,725.924 578.5,775C 495.888,808.605 411.555,813.605 325.5,790C 227.393,758.876 152.893,698.71 102,609.5C 53.6095,516.37 43.9428,419.37 73,318.5C 110.023,208.143 181.857,129.643 288.5,83C 325.341,68.4552 363.341,59.2886 402.5,55.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 277.5,182.5 C 322.501,182.333 367.501,182.5 412.5,183C 439.753,188.252 456.587,204.419 463,231.5C 463.667,268.5 463.667,305.5 463,342.5C 456.612,370.888 439.112,387.722 410.5,393C 366.167,393.667 321.833,393.667 277.5,393C 251.092,385.927 234.925,369.093 229,342.5C 228.333,305.5 228.333,268.5 229,231.5C 235.339,205.328 251.506,188.995 277.5,182.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b2bb5",
    d: "M 280.5,209.5 C 323.168,209.333 365.835,209.5 408.5,210C 422.347,212.844 431.513,221.01 436,234.5C 436.667,269.167 436.667,303.833 436,338.5C 432.846,353.654 423.68,362.82 408.5,366C 366.167,366.667 323.833,366.667 281.5,366C 268.333,362.167 259.833,353.667 256,340.5C 255.333,305.167 255.333,269.833 256,234.5C 260.352,222.316 268.518,213.983 280.5,209.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fdfdfe",
    d: "M 482.5,367.5 C 532.501,367.333 582.501,367.5 632.5,368C 659.563,374.063 676.397,390.563 683,417.5C 683.667,454.833 683.667,492.167 683,529.5C 678.702,559.797 661.535,577.63 631.5,583C 581.5,583.667 531.5,583.667 481.5,583C 454.47,576.637 438.304,559.803 433,532.5C 432.333,494.167 432.333,455.833 433,417.5C 439.678,390.989 456.178,374.323 482.5,367.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2b2bb5",
    d: "M 485.5,392.5 C 532.835,392.333 580.168,392.5 627.5,393C 643.661,395.493 653.827,404.66 658,420.5C 658.667,456.5 658.667,492.5 658,528.5C 654.806,545.027 644.973,554.86 628.5,558C 580.5,558.667 532.5,558.667 484.5,558C 469.698,553.531 460.865,543.698 458,528.5C 457.333,492.5 457.333,456.5 458,420.5C 462.016,405.985 471.183,396.652 485.5,392.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfbfd",
    d: "M 326.5,514.5 C 348.206,514.068 369.873,514.568 391.5,516C 415.94,523.773 430.44,540.273 435,565.5C 435.667,589.5 435.667,613.5 435,637.5C 430.609,665.89 414.443,683.39 386.5,690C 366.167,690.667 345.833,690.667 325.5,690C 299.427,682.93 284.26,666.096 280,639.5C 279.333,613.833 279.333,588.167 280,562.5C 285.904,537.097 301.404,521.097 326.5,514.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#2c2bb5",
    d: "M 329.5,537.5 C 347.836,537.333 366.17,537.5 384.5,538C 399.18,542.68 408.346,552.513 412,567.5C 412.667,590.5 412.667,613.5 412,636.5C 409.354,653.144 399.854,663.311 383.5,667C 365.167,667.667 346.833,667.667 328.5,667C 315.168,662.334 306.668,653.167 303,639.5C 302.333,614.5 302.333,589.5 303,564.5C 307.377,550.958 316.21,541.958 329.5,537.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCubeLogo);
export default __webpack_public_path__ + "static/media/code-cube-logo.9a389bf59e86f4ea509343d74f8ed448.svg";
export { ForwardRef as ReactComponent };